export default [
  {
    itemType: 'tabbed',
    tabPanelOptions: {
      deferRendering: false
    },
    tabs: [
      {
        title: 'Dados Principais',
        items: [
          {
            itemType: 'group',
            colCount: 4,
            items: [
              {
                dataField: 'nome',
                label: { text: 'Nome' },
                validationRules: [{
                  type: 'required',
                  message: 'Nome é obrigatório'
                }]
              },
              {
                template: 'grupo'
              },
              {
                template: 'desconto'
              },
              {
                template: 'preco'
              },
              {
                template: 'segmento'
              }
            ]
          }
        ]
      }
    ]
  }
]
